export const Envs = {
  BFF_WEB_URL: process.env['NEXT_PUBLIC_HUB_API'] ?? process.env['REACT_APP_HUB_API'] ?? process.env['NX_BFF_WEB_URL'],
  BFF_MEMBERS_AREA_URL:
    process.env['NEXT_PUBLIC_BFF_MEMBERS_AREA_URL'] ??
    process.env['REACT_APP_BFF_MEMBERS_AREA_URL'] ??
    process.env['NX_BFF_MEMBERS_AREA_URL'],
}
